import { createAsyncThunk } from "@reduxjs/toolkit";
import api, { TOKEN } from "../../api/axiosInstance";

export const me = createAsyncThunk("user/me", async () => {
  const token = await window.localStorage.getItem(TOKEN);
  if (token) {
    const res = await api.get("");
    return res.data;
  }
});

export const getUserFromSession = createAsyncThunk(
  "user/getUserFromSession",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/getUserFromSession");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const update = createAsyncThunk(
  "user/update",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { first_name, last_name, email, phone_number, birthday, street_address, city, state, country } = formInfo;
      const res = await api.post("user", {
        first_name,
        last_name,
        email,
        phone_number,
        birthday,
        street_address,
        city,
        state,
        country,
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getPreferences = createAsyncThunk(
  "user/getPreferences",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/preferences");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getProfilePicture = createAsyncThunk(
  "user/getProfilePicture",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("user/profilePicture");
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const setProfilePicture = createAsyncThunk(
  "user/setProfilePicture",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { selectedFile } = formInfo;
      const formData = new FormData();
      formData.append("profile_pic", selectedFile);
      const res = await api.post("user/profilePicture", formData);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getAccountValues = createAsyncThunk(
  "user/getAccountValues",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { filters } = formInfo;
      const res = await api.get("user/accountValue", { params: filters });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const setAccountValue = createAsyncThunk(
  "user/setAccountValue",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { accountvalue, date } = formInfo;
      const res = await api.post("user/accountValue", { accountvalue, date });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const toggleAvTracking = createAsyncThunk(
  "user/toggleAvTracking",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.post("user/preferences/toggleav", {});
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const toggleEmailOptin = createAsyncThunk(
  "user/toggleEmailOptin",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.post("user/preferences/toggleeoi", {});
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const toggleFeatureFlags = createAsyncThunk(
  "user/toggleFeatureFlags",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { flags } = formInfo;
      const res = await api.post("user/preferences/toggleff", flags);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const updatePreferredCurrency = createAsyncThunk(
  "user/updatePreferredCurrency",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { preferred_currency } = formInfo;
      const res = await api.post("user/preferences/updatecurrency", { preferred_currency });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const updatePreferredTwoFAMethod = createAsyncThunk(
  "user/updatePreferredTwoFAMethod",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { preferred_2fa_method } = formInfo;
      const res = await api.post("user/preferences/update2famethod", { preferred_2fa_method });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const setUsername = createAsyncThunk(
  "user/setUsername",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { username } = formInfo;
      const res = await api.put("user/username", { username });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const checkUsernameAvailability = createAsyncThunk(
  "user/checkUsernameAvailability",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { username } = formInfo;
      const res = await api.get(`user/username/check?username=${username}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const getPublicProfile = createAsyncThunk(
  "user/getPublicProfile",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { username } = formInfo;
      const res = await api.get(`u/${username}`);
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);

export const reportBug = createAsyncThunk(
  "user/reportBug",
  async (formInfo, { rejectWithValue }) => {
    try {
      const { requestType, summary, description, page } = formInfo;
      const res = await api.post("user/reportBug", {
        requestType,
        summary,
        description,
        page,
      });
      return res.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  }
);
